import { createModuleStreamFetcher } from './createModuleStreamFetcher';

export default createModuleStreamFetcher({
  url: '/module/my_comments',
});
